import React, { useEffect, useRef } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './components/GlobalMobile.css'; 
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase';

import AdminAuthWrapper from './AdminAuthWrapper';
import HomePage from './pages/HomePage';
import HowItWorks from './pages/HowItWorks';
import Pricing from './pages/Pricing';
import FAQs from './pages/FAQs';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import PastNumbers from './pages/PastNumbers';
import ProfilePage from './pages/ProfilePage';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import SignupSuccess from './pages/SignupSuccess';
import SignupStepOne from './pages/SignupStepOne';
import SignupStepTwo from './pages/SignupStepTwo';
import SignupStepThree from './pages/SignupStepThree';

import MainLayout from './layouts/MainLayout';
import PasswordGate from './PasswordGate'; // Add this import

const App = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

// Scroll to top on every route change
const location = useLocation();
useEffect(() => {
  window.scrollTo(0, 0);
}, [location.pathname]);

  useEffect(() => {
    const resetInactivityTimer = () => startInactivityTimer();

    const startInactivityTimer = () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        signOut(auth).then(() => {
          navigate('/login');
          alert("You've been logged out due to inactivity.");
        });
      }, 30 * 60 * 1000); // 30 minutes
    };

    const addUserActivityListeners = () => {
      ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(event =>
        window.addEventListener(event, resetInactivityTimer)
      );
    };

    const removeUserActivityListeners = () => {
      ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(event =>
        window.removeEventListener(event, resetInactivityTimer)
      );
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        startInactivityTimer();
        addUserActivityListeners();
      } else {
        clearTimeout(timeoutRef.current);
        removeUserActivityListeners();
      }
    });

    return () => {
      unsubscribe();
      clearTimeout(timeoutRef.current);
      removeUserActivityListeners();
    };
  }, [navigate]);

  return (
    <PasswordGate>
      <Routes>
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/how-it-works" element={<MainLayout><HowItWorks /></MainLayout>} />
        <Route path="/pricing" element={<MainLayout><Pricing /></MainLayout>} />
        <Route path="/faqs" element={<MainLayout><FAQs /></MainLayout>} />
        <Route path="/login" element={<MainLayout><Login /></MainLayout>} />
        <Route path="/signup" element={<MainLayout><SignupStepOne /></MainLayout>} />
        <Route path="/signup/terms" element={<MainLayout><SignupStepTwo /></MainLayout>} />
        <Route path="/signup/preferences" element={<MainLayout><SignupStepThree /></MainLayout>} />
        <Route path="/signup-success" element={<MainLayout><SignupSuccess /></MainLayout>} />
        <Route path="/profile" element={<MainLayout><ProfilePage /></MainLayout>} />
        <Route path="/past-numbers" element={<MainLayout><PastNumbers /></MainLayout>} />
        <Route path="/terms" element={<MainLayout><Terms /></MainLayout>} />
        <Route path="/privacy" element={<MainLayout><Privacy /></MainLayout>} />
        <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />

        {/* These stay unwrapped */}
        <Route path="/admin-dashboard" element={<AdminAuthWrapper />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PasswordGate>
  );
};

export default App;